/**
 * Utilidades para validar y trabajar con iconos
 */

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

/**
 * Valida si un valor es un icono de FontAwesome
 *
 * @param icon - Valor a validar
 * @returns true si es un icono de FontAwesome válido
 */
export const isFontAwesomeIcon = (icon: unknown): icon is IconProp => {
  if (typeof icon !== 'object' || icon === null) return false;
  if (!('icon' in icon)) return false;
  // Validar estructura básica de FontAwesome (icon debe ser un array)
  const faIcon = icon as { icon?: unknown };
  return Array.isArray(faIcon.icon) && faIcon.icon.length >= 2;
};

/**
 * Detecta si un string es un emoji
 *
 * @param str - String a verificar
 * @returns true si el string es un emoji
 */
export const isEmoji = (str: string): boolean => {
  if (!str || str.length === 0) return false;

  // Verificar si es un nombre de icono de FontAwesome (contiene solo letras, números, guiones)
  if (/^[a-zA-Z0-9-]+$/.test(str)) return false;

  // Verificar que el string completo sea un emoji (no solo que contenga uno)
  // Un emoji típicamente tiene 1-4 caracteres (incluyendo variaciones y modificadores)
  const emojiRegex = /^\p{Emoji}+$/u;
  return emojiRegex.test(str) && str.length <= 4;
};
